export { default } from './InputAdornment';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/InputAdornment/index.js
// module id = 236
// module chunks = 2